module.exports = __webpack_public_path__ + "img/united-states.5e960fde.svg";